import './Page3346Style.css';

function Page3346Success() {

  return (
    <div className="Aa3346">
      <div className='container'>
        <div className='form-content'>
          <div className='title'>
            <h4 id='headup-title'>Загрузка готова</h4>
          </div>
          <div className='form-content-top'>
            <div className='logo'><img fetchpriority='high' alt='Ready' src='/tick.avif' /></div>
          </div>
          <div className='form-content-middle'>
            <div className='title'>
              <h3 id='title'>Операция завершена успешно</h3>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default Page3346Success;